import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./components/Context/AuthContext";
import HomePage from "./HomePage";
import LoginPage from "./components/Pages/LoginPage";
import Nav from "./components/Nav";
import Outils from "./components/Outils";
import SquareOrderForm from "./components/SquareOrderForm";
import CommandeModal from "./components/CommandeModal";
import { usePanier, PanierElement } from "./PanierContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuth();
  if (!user) return <LoginPage />;
  return <>{children}</>;
};

const App: React.FC = () => {
  const { panier } = usePanier();

  // ✅ Gestion de la modale de commande
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customerId, setCustomerId] = useState<string>(() => {
    try {
      const saved = localStorage.getItem("customerId");
      return saved ? JSON.parse(saved) : "";
    } catch {
      return "";
    }
  });
  const [orderId, setOrderId] = useState<string>(() => {
    try {
      const saved = localStorage.getItem("orderId");
      return saved ? JSON.parse(saved) : "";
    } catch {
      return "";
    }
  });

  useEffect(() => {
    localStorage.setItem("customerId", JSON.stringify(customerId));
  }, [customerId]);

  useEffect(() => {
    localStorage.setItem("orderId", JSON.stringify(orderId));
  }, [orderId]);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          {/* Nav reçoit la fonction pour ouvrir la modale */}
          <Nav openCommandeModal={() => setIsModalOpen(true)} />
          <div style={{ height: "60px" }}></div>

          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/commande" element={<SquareOrderForm />} />
            <Route path="/outils" element={<Outils />} />
          </Routes>

          {/* ✅ Modale de commande centralisée */}
          <CommandeModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            saveUserId={(newId) => setCustomerId(newId)}
            customerId={customerId}
            saveOrderId={(newId) => setOrderId(newId)}
            orderId={orderId}
            panier={panier}
          />

          <ToastContainer />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
};

export default App;
